import * as urlUtils from 'utils/Url';
import constants from 'Constants';
import { getAuth, patchAuth, postAuth, deleteAuth } from '../Utils';



// Broadcast
export function getViewManageBroadcasts(successCallback, errorCallback, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(`view/manage-broadcasts`, qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

function pathBroadcasts(broadcastId=null) {
  if (broadcastId) {
      return `broadcasts/${broadcastId}`;
  } else {
      return `broadcasts`;
  }
}

export function createBroadcasts(successCallback, errorCallback, data) {
  postAuth({
    "path": pathBroadcasts(),
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}

export function deleteBroadcasts(successCallback, errorCallback, broadcastId) {
  deleteAuth({
    "path": pathBroadcasts(broadcastId),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

export function sendNowBroadcasts(successCallback, errorCallback, broadcastId) {
  postAuth({
    "path": `broadcasts/${broadcastId}/send-now`,
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

export function cancelBroadcasts(successCallback, errorCallback, broadcastId) {
  postAuth({
    "path": `broadcasts/${broadcastId}/cancel`,
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

export function estimateBroadcastSize(successCallback, errorCallback, data) {
  postAuth({
    "path": `broadcasts/estimate-size`,
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}

